module.exports = __webpack_public_path__ + "static/media/photo4.9e8fa389.jpg";